import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import { getToken, deCode } from '@/utils/cookie'
import store from './store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/test']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  // 已经登陆
  if (getToken()) {
    if (to.path === '/login') {
      next('/')
      NProgress.done()
    } else {
      // 已成功加载用户信息
      if (store.state.user.loaded) {
        next()
      } else {
        // 登陆，但是没有角色，需要获取角色
        try {
          const { pagePermissions } = await store.dispatch('user/myInfo')
          // 按权限过滤路由
          if (pagePermissions) {
            const accessRoutes = await store.dispatch('permission/generateRoutes', new Set(pagePermissions))
            for (const route of accessRoutes) {
              router.addRoute(route)
            }
          }

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next({
            ...to,
            replace: true
          })
        } catch (error) {
          if (!store.state.user.showReLoginDialog) {
            // remove token and go to login page to re-login
            await store.dispatch('user/clearToken')
            // vue.$message.error(error.message || 'Error')
            if (to.path.startsWith('/wx')) {
              window.location.replace('http://' + process.env.VUE_APP_HOST + '/wx/login?reset=true')
            } else {
              next(`/login?redirect=${to.path}`)
            }
          }
        }
      }
    }
  } else {
    // 没有登陆
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else if (to.path.startsWith('/wx')) {
      // 公众号自动重新登陆
      if (to.query.openid) {
        store.dispatch('user/login', { openid: to.query.openid }).then(() => {
          store.dispatch('user/myInfo').then(() => {
            next()
          })
        })
      } else if (to.query.account) {
        store.dispatch('user/login', { account: deCode(to.query.account), password: deCode(to.query.password) }).then(() => {
          store.dispatch('user/myInfo').then(() => {
            next()
          })
        })
      } else if (to.fullPath === '/wx-car-search') {
        next()
      } else {
        window.location.replace('http://' + process.env.VUE_APP_HOST + '/wx/login?reset=true')
      }
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
